import type { ProfileType } from '@/components/pages/giveaway-picker/Types/types';

export const GetSelectedProfile = (t: (key: string) => string, selectedProfile: ProfileType) => {
    if (!selectedProfile) {
        return {
            value: '',
            label: t('account_selection.select_account'),
            profile: null
        };
    }
    return {
        value: selectedProfile.id,
        label: selectedProfile.username,
        profile: selectedProfile
    };
};
